import { Controller } from "@hotwired/stimulus"

// Opens the send-document modal by pointing its turbo-frame at the
// modal URL. The URL is provided as a Stimulus value rather than
// constructed inline so a route change in config/routes.rb only needs
// to update the ERB call site (`url-value` data attr) — not this JS
// file.
export default class extends Controller {
  static values = {
    documentId: String,
    url: String
  }

  open() {
    const frame = document.querySelector('turbo-frame[id="send_modal_frame"]')
    if (!frame) return

    const path = this.urlValue || `/practitioners/documents/${this.documentIdValue}/send_modal`
    frame.src = path
  }
}
